export * from './course-event-modal.component';
